import { formatDate } from '@angular/common';

/**
 * convert Epoch To Date String
 * @param epoch
 * @returns
 */
export function convertEpochToDateString(epoch: number): string {
	try {
		const date = new Date(epoch);
		return formatDate(date, "dd MMM YYYY HH:mm:ss", "en-en")
	}
	catch (ex) {
		return ""
	}
}

/**
 * generateGUID
 * @returns
 */
export function generateGUID(): string {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	}).toUpperCase();
}
